import React from 'react';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import numeral from 'numeral';

/**
 * "N active / M total" badge for the contact/investor card header (GEN-2367).
 * currentCount = warnings present in the latest completed DI run, totalUniqueCount
 * = distinct (rule, field) warnings ever triggered for the record.
 */
const DataIntegrityWarningsBadge = ({ currentCount, totalUniqueCount, fetching, titleClassName, subtitleClassName }) => (
  <div>
    <Typography variant="h5" className={titleClassName}>
      Data Integrity Warnings
    </Typography>
    <span className={subtitleClassName}>
      {fetching
        ? <Skeleton width={70} />
        : `${numeral(currentCount || 0).format('0,0')} active / ${numeral(totalUniqueCount || 0).format('0,0')} total`}
    </span>
  </div>
);

export default DataIntegrityWarningsBadge;
